import { PERMISSION_KEYS } from 'constants-permissions';
import { ALL_ACTIONS, READ_ONLY_ACTIONS } from '../Action';
import {
  hasAnyPermission,
  isAssigneeOrTeamMember,
  isOwner,
  isSuperUser,
} from '../predicates';
import type { PreventiveMaintenanceResource } from '../Resource';
import { evaluateRules, type AccessRequest, type Rule } from '../Rule';

export const PM_TASK_RULES: readonly Rule<PreventiveMaintenanceResource>[] = [
  { name: 'superuser', actions: ALL_ACTIONS, appliesTo: isSuperUser },
  {
    name: 'admin',
    actions: ALL_ACTIONS,
    appliesTo: hasAnyPermission([PERMISSION_KEYS.PERMISSION_ADMIN]),
  },
  { name: 'owner', actions: ALL_ACTIONS, appliesTo: isOwner },
  {
    name: 'attach-file',
    actions: ALL_ACTIONS,
    appliesTo: hasAnyPermission([
      PERMISSION_KEYS.PERMISSION_WORK_ORDERS_PM_TASK_ATTACH_FILE,
    ]),
  },
  {
    name: 'view-all',
    actions: READ_ONLY_ACTIONS,
    appliesTo: hasAnyPermission([
      PERMISSION_KEYS.PERMISSION_WORK_ORDERS_PM_TASK_VIEW,
    ]),
  },
  {
    name: 'assignee-team',
    actions: READ_ONLY_ACTIONS,
    appliesTo: isAssigneeOrTeamMember,
  },
];

export const canAccessPmTaskAttachment = (
  request: AccessRequest<PreventiveMaintenanceResource>
): boolean => evaluateRules(PM_TASK_RULES, request);
